module.exports = __webpack_public_path__ + "static/upload-illus-01ae4f07f0357c731d128614e9a31549.svg";